// extracted by mini-css-extract-plugin
export var container = "Outro-module--container--294b3";
export var cta = "Outro-module--cta--521dd";
export var mascot = "Outro-module--mascot--14d6b";
export var wrapper = "Outro-module--wrapper--183a9";